export const TRANSLATIONS_PT_PLANS_AND_ADMIN = {
  "usage.period.month": "este mês",
  "usage.hero.title": "Consumo principal do período",
  "usage.hero.used": "usado",
  "usage.hero.no_data": "Sem dados ainda",
  "admin.title": "Administração",
  "admin.members": "Membros",
  "admin.invite": "Convidar",
  "admin.pending": "Convites pendentes",
  "admin.roles": "Funções",
  "admin.experts": "Especialistas",
  "admin.experts.title": "Especialistas da conta",
  "admin.experts.subtitle": "Ative os especialistas que sua conta usará, como plugins. Só os ativados aparecem no chat. A configuração de cada especialista é do sistema.",
  "admin.experts.enabledCount": "ativados",
  "admin.experts.loading": "Carregando especialistas…",
  "admin.experts.loadError": "Não foi possível carregar os especialistas.",
  "admin.experts.saveError": "Não foi possível atualizar o especialista.",
  "admin.experts.enabled": "Ativo",
  "admin.experts.disabled": "Inativo",
  "admin.experts.enable": "Ativar",
  "admin.experts.disable": "Desativar",
  "admin.experts.tooltipTitle": "Como enriquece sua consulta",
  "admin.experts.customBadge": "Personalizado",
  "admin.experts.create": "Criar especialista",
  "admin.experts.createTitle": "Novo especialista",
  "admin.experts.createSubtitle": "Este especialista será privado da sua conta. Diga como ele deve responder; nós montamos o resto.",
  "admin.experts.fieldName": "Nome",
  "admin.experts.fieldNamePlaceholder": "Ex. Especialista em contratos",
  "admin.experts.fieldDescription": "Descrição curta (opcional)",
  "admin.experts.fieldDescriptionPlaceholder": "Ex. Revisa contratos e aponta riscos",
  "admin.experts.fieldIcon": "Ícone",
  "admin.experts.fieldInstruction": "Como deve responder?",
  "admin.experts.fieldInstructionPlaceholder": "Ex. Atue como advogado de contratos: identifique cláusulas-chave, obrigações e riscos, e sugira o que revisar. Seja claro e prudente.",
  "admin.experts.instructionHint": "Escreva em linguagem natural. Nós transformamos no comportamento do especialista.",
  "admin.experts.createSubmit": "Criar",
  "admin.experts.creating": "Criando…",
  "admin.experts.createError": "Não foi possível criar o especialista.",
  "admin.experts.cancel": "Cancelar",
  "admin.experts.delete": "Excluir",
  "admin.experts.deleteConfirm": "Excluir o especialista",
  "admin.experts.deleteError": "Não foi possível excluir o especialista.",
  "admin.settings.title": "Administração",
  "admin.settings.organizationName": "Nome da organização",
  "admin.settings.inviteExpiryDays": "Dias de expiração do convite (1-60)",
  "admin.settings.allowedDomains": "Domínios permitidos (separados por vírgula ou linha)",
  "admin.settings.defaultRole": "Função padrão",
  "admin.settings.locale": "Localidade",
  "admin.members.title": "Membros da organização",
  "admin.invite.title": "Convidar usuário",
  "admin.invite.send": "Enviar convite",
  "admin.invite.invitations": "Convites",
  "admin.invite.resend": "Reenviar convite",
  "admin.invite.revoke": "Revogar convite",
  "admin.invite.empty": "Não há convites para exibir.",
  "admin.roles.title": "Funções e permissões",
  "admin.roles.permissions": "Permissões",
  "admin.roles.delete": "Excluir função",
};
